import LabFullLayout from '../layout/LabfullLayout';
import LabLayout from '../layout/LabLayout';
import Home from '../pages/lab/home';
import LabInformationForm from '../pages/lab/informationForm';
import LabLocationForm from '../pages/lab/locationForm';
import Manage from '../pages/lab/manage';
import About from '../pages/lab/manage/about';
import Comments from '../pages/lab/manage/comments';
import ShopRules from '../pages/lab/manage/rules';
import ShopSupport from '../pages/lab/manage/support';
import LabMessages from '../pages/lab/message';
import ShopOwnerForm from '../pages/lab/ownerForm';
import SelectLabActivity from '../pages/lab/selectActivity';
import SelectCertificates from '../pages/lab/selectCertificates';
import SelectTests from '../pages/lab/selectTests';
import type {AppRouteConfig} from './route.types';

export const labRoutes: AppRouteConfig[] = [
  {
    path: 'lab',
    element: LabLayout,
    children: [
      {path: 'home', element: Home},
      {path: 'message', element: LabMessages},
      {path: 'manage', element: Manage},
      {path: 'manage/about', element: About},
      {path: 'manage/support', element: ShopSupport},
      {path: 'manage/rules', element: ShopRules},
      {path: 'manage/comment', element: Comments},
    ],
  },
  {
    path: 'lab',
    element: LabFullLayout,
    children: [
      {path: 'edit/activity', element: SelectLabActivity},
      {path: 'edit/services', element: SelectTests},
      {path: 'edit/info', element: LabInformationForm},
      {path: 'edit/location', element: LabLocationForm},
      {path: 'edit/owner', element: ShopOwnerForm},
      {path: 'edit/license', element: SelectCertificates},
    ],
  },
];
